import React from 'react';
import { Brain, Check, LockKeyhole } from 'lucide-react';
import type { ReasoningPreference } from '../types';
import type { SubscriptionTier } from '../config/subscriptionPlans';
import { canUseReasoningPreference } from '../shared/reasoningPreference';
import ComposerPopover from './ComposerPopover';

interface ReasoningSelectorProps {
  value: ReasoningPreference;
  userTier: SubscriptionTier;
  onChange: (value: ReasoningPreference) => void;
  disabled?: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const OPTIONS: Array<{ value: ReasoningPreference; label: string; requirement?: string }> = [
  { value: 'normal', label: 'Normal' },
  { value: 'high', label: 'Alto', requirement: 'Plan Profesional' },
  { value: 'max', label: 'Máximo', requirement: 'Plan Premium' }
];

const ReasoningSelector: React.FC<ReasoningSelectorProps> = ({ value, userTier, onChange, disabled = false, open, onOpenChange }) => (
  <ComposerPopover label={`Nivel de razonamiento: ${OPTIONS.find((option) => option.value === value)?.label}`}
    open={open} onOpenChange={onOpenChange} disabled={disabled} align="right"
    trigger={<span className="relative"><Brain size={22} aria-hidden="true" />{value !== 'normal' && <span aria-hidden="true" className="absolute left-1/2 -translate-x-1/2 -top-2 flex h-3.5 min-w-3.5 items-center justify-center rounded bg-panel px-0.5 text-[10px] font-bold leading-none text-juris">{value === 'high' ? 'A' : 'M'}</span>}</span>}>
    <p className="px-3 pb-2 pt-1 text-xs font-medium text-muted">Razonamiento</p>
    {OPTIONS.map((option) => {
      const available = canUseReasoningPreference(option.value, userTier);
      return <button key={option.value} type="button" role="menuitemradio" tabIndex={-1} aria-checked={value === option.value}
        disabled={disabled || !available} onClick={() => {
          if (!disabled && available) onChange(option.value);
        }} className="flex min-h-11 w-full items-center justify-between gap-3 rounded-xl px-3 py-2.5 text-left text-sm text-ink transition-colors hover:bg-juris-soft disabled:cursor-not-allowed disabled:text-muted disabled:hover:bg-transparent">
        <span><span className="block font-medium">{option.label}</span>{!available && <span className="block text-xs text-muted">{option.requirement}</span>}</span>
        {!available ? <LockKeyhole size={16} aria-hidden="true" /> : value === option.value ? <Check size={18} className="text-juris" aria-hidden="true" /> : null}
      </button>;
    })}
  </ComposerPopover>
);

export default ReasoningSelector;
